import { withStyles } from '@material-ui/core';

const withDynamicStyles = (styles) => (Component) => {
  return (props) => {
    const { theme } = props;
    const DynamicStyles = withStyles(() => styles(theme))(Component);
    return <DynamicStyles {...props} />;
  };
};

export { withDynamicStyles };
